import { momentWithLocale as moment } from './i18n.js';

export const formats = {
    CLIENT_DATE_FORMAT: 'DD.MM.YYYY',
    DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm',
    FLIGHT_DAY_TIME_FORMAT: 'dd. HH:mm',
    FLIGHT_DURATION_FORMAT: 'HHh mm',
    FLIGHT_FULL_DATE_FORMAT: 'dddd Do MMMM YYYY',
    READABLE_DATE_FORMAT_SHORT: 'ddd DD.MM',
    READABLE_DATE_FORMAT: 'ddd DD MMM',
    SERVER_DATE_FORMAT: 'YYYY-MM-DD',
    READABLE_TIME_FORMAT: 'ddd HH:mm',
    TIME_FORMAT: 'HH:mm',
};

// Returns moment object from date string
export function serverDate(date) {
    return moment(date, formats.SERVER_DATE_FORMAT);
}

export function clientDate(date) {
    return moment(date, formats.CLIENT_DATE_FORMAT);
}

// Returns formatted date string from moment object
export function formatServerDate(date) {
    return date ? moment(date).format(formats.SERVER_DATE_FORMAT) : null;
}

export function formatClientDate(date) {
    return date ? moment(date).format(formats.CLIENT_DATE_FORMAT) : null;
}

// Returns number of days between start and end date strings
export function daysBetween(start, end) {
    return 1 + serverDate(end).diff(serverDate(start).startOf('day'), 'days');
}

// Returns date in future as server date string
export function plusDays(date, days) {
    return serverDate(date)
        .add(days, 'days')
        .format(formats.SERVER_DATE_FORMAT);
}

// Returns date in past as server date string
export function minusDays(date, days) {
    return serverDate(date)
        .subtract(days, 'days')
        .format(formats.SERVER_DATE_FORMAT);
}

export function secondsToDateTime(secondsSinceEpoch) {
    return moment.utc(secondsSinceEpoch * 1000).format(formats.DATE_TIME_FORMAT);
}

export function secondsToReadableTime(seconds) {
    return moment.utc(seconds * 1000).format(formats.READABLE_TIME_FORMAT);
}

export function dateTimeToSeconds(dateTime) {
    return moment.utc(dateTime, formats.DATE_TIME_FORMAT).unix();
}
